import { Capacitor } from '@capacitor/core';

/**
 * Base URL of the web app, without a trailing slash.
 *
 * On native there is no meaningful `window.location.origin`, so fall back to
 * the production web domain (app.volyx.app). `VITE_APP_URL` overrides both
 * (useful for dev/staging).
 */
export function getWebAppBaseUrl(): string {
  const base =
    import.meta.env.VITE_APP_URL ??
    (Capacitor.isNativePlatform() ? 'https://app.volyx.app' : window.location.origin);
  return base.replace(/\/$/, '');
}
